import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const PlasticFree = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.666992"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        fill="white"
      />
      <rect
        x="0.666992"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        stroke="#E2DFDF"
      />
      <circle
        cx="19.5605"
        cy="40.6074"
        r="5.77148"
        fill={productBackground || color}
      />
      <path
        d="M45.167 30C45.167 38.2843 38.4513 45 30.167 45C21.8827 45 15.167 38.2843 15.167 30C15.167 21.7157 21.8827 15 30.167 15C38.4513 15 45.167 21.7157 45.167 30Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5605 40.6074L40.7738 19.3942"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M34.1615 20.9754C33.6572 20.9754 33.2318 21.3509 33.1692 21.8513L32.7658 25.0786C32.7032 25.5791 32.2778 25.9546 31.7735 25.9546H28.5598C28.0555 25.9546 27.6301 25.5791 27.5675 25.0786L27.1641 21.8513C27.1016 21.3509 26.6762 20.9754 26.1719 20.9754H24.8445C24.332 20.9754 23.9025 21.3627 23.8498 21.8725L22.2884 36.9658C22.1745 38.0671 23.0385 39.0251 24.1458 39.0251H36.1876C37.2948 39.0251 38.1589 38.0671 38.0449 36.9658L36.4835 21.8725C36.4308 21.3627 36.0013 20.9754 35.4888 20.9754H34.1615Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
